import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { PureComponent } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { createStatusAnalyticsAndFire } from './analytics';
import { ANALYTICS_HOVER_DELAY } from './constants';

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
const colorToLozengeAppearanceMap = {
  neutral: 'default',
  purple: 'new',
  blue: 'inprogress',
  red: 'removed',
  yellow: 'moved',
  green: 'success'
};
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */

const DEFAULT_APPEARANCE = 'default';
const MAX_WIDTH = 200;

class StatusInternal extends PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "hoverStartTime", 0);

    _defineProperty(this, "handleMouseEnter", _e => {
      this.hoverStartTime = Date.now();
    });

    _defineProperty(this, "handleMouseLeave", _e => {
      const {
        onHover
      } = this.props;
      const delay = Date.now() - this.hoverStartTime;

      if (delay >= ANALYTICS_HOVER_DELAY && onHover) {
        onHover();
      }

      this.hoverStartTime = 0;
    });
  }

  componentWillUnmount() {
    this.hoverStartTime = 0;
  }

  render() {
    const {
      text,
      color,
      style,
      role,
      onClick
    } = this.props;

    if (text.trim().length === 0) {
      return null;
    }

    const appearance = colorToLozengeAppearanceMap[color] || DEFAULT_APPEARANCE; // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId

    return /*#__PURE__*/React.createElement("span", {
      className: "status-lozenge-span",
      onClick: onClick,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      "data-node-type": "status",
      "data-color": color,
      "data-style": style,
      role: role
    }, /*#__PURE__*/React.createElement(Lozenge, {
      appearance: appearance,
      maxWidth: MAX_WIDTH
    }, text));
  }

}

_defineProperty(StatusInternal, "displayName", 'StatusInternal');

export const Status = withAnalyticsEvents({
  onClick: (createEvent, props) => {
    const {
      localId
    } = props;
    return createStatusAnalyticsAndFire(createEvent)({
      action: 'clicked',
      actionSubject: 'statusLozenge',
      attributes: {
        localId
      }
    });
  },
  onHover: (createEvent, props) => {
    const {
      localId
    } = props;
    return createStatusAnalyticsAndFire(createEvent)({
      action: 'hovered',
      actionSubject: 'statusLozenge',
      attributes: {
        localId
      }
    });
  }
})(StatusInternal);